import React from "react";
import * as procService from "../../services/procService";
import { useModule } from "../Platform/ModuleGate";
import { hasModulePermission } from "../../constants/platformModules";
import { MessagesPage } from "./Chat";

// Buyer: every conversation with a supplier.
const loadSuppliers = async () => {
  const res = await procService.listSuppliers({ status: "ACTIVE" });
  return (res?.data || []).filter((s) => s.company_profile_id).map((s) => ({ label: s.supplier_name, ref: { supplier_id: s.company_profile_id } }));
};

export default function Messages() {
  const { access } = useModule();
  const canWrite = hasModulePermission(access, "PROC", "PROC_ADMIN", "PROC_BUYER");
  return <MessagesPage service={procService} side="BUYER" loadParties={loadSuppliers} canWrite={canWrite} />;
}
